import * as moment from "moment";
import { action } from "satcheljs";
import { IAvailabilityEntity, IShiftEntity } from "sh-models";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const handleConflictManagement = action(
    "HANDLE_CONFLICT_MANAGEMENT",
    (
        viewState: IPreviewSchedulePageStore | SchedulesViewStateStore,
        shiftsAdded: IShiftEntity[],
        shiftsDeleted: IShiftEntity[],
        shiftsUpdated: IShiftEntity[],
        viewStartDatetime: moment.Moment,
        viewEndDatetime: moment.Moment,
        forceCalculate?: boolean,
        availabilities?: Map<string, IAvailabilityEntity[]>,
        calculateConflicts?: boolean,
        refreshConflictsCallback?: Function
    ) => ({
        viewState,
        shiftsAdded: shiftsAdded || [],
        shiftsDeleted: shiftsDeleted || [],
        shiftsUpdated: shiftsUpdated || [],
        viewStartDatetime: viewStartDatetime,
        viewEndDatetime: viewEndDatetime,
        forceCalculate: forceCalculate,
        availabilities: availabilities,
        calculateConflicts: calculateConflicts,
        refreshConflictsCallback: refreshConflictsCallback
    })
);

export default handleConflictManagement;